


















































































import Vue, { PropType } from "vue";
import { ValidationObserver } from "vee-validate";
// types
import { Publisher } from "@/features/coreWebVitals/types";
// util
import * as notifyUtil from "@/commons/utils/notifyUtil";

export default Vue.extend({
  components: {
    "validation-observer": ValidationObserver,
  },
  props: {
    publishersInput: { type: Array as PropType<number[]> },
    publishers: {
      type: Array as PropType<Publisher[]>,
      required: true,
    },
    formSearchValue: {
      type: String,
      default: "",
    },
    fetchData: { type: Function as PropType<() => void>, required: true },
    isDomainsLoading: { type: Boolean, required: true },
    isPublishersLoading: { type: Boolean, required: true },
  },

  computed: {
    localPublishersInput: {
      get(): number[] {
        return (this as any).publishersInput;
      },
      set(val: number[]) {
        return this.$emit("update:publishersInput", val);
      },
    },
  },
  methods: {
    handleFetchData() {
      if ((this as any).isDomainsLoading) {
        notifyUtil.notifyErrorMessage(this.$t("general.notify.error.loading"));
      } else {
        (this as any).fetchData();
      }
    },
  },
});
